module.exports = __webpack_public_path__ + "static/img/9.d0fbc3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/version/01/9.png
// module id = gqcO
// module chunks = 1